import { render, staticRenderFns } from "./PsPatients.vue?vue&type=template&id=2cda63ae&scoped=true&"
import script from "./PsPatients.vue?vue&type=script&lang=js&"
export * from "./PsPatients.vue?vue&type=script&lang=js&"
import style0 from "./PsPatients.vue?vue&type=style&index=0&id=2cda63ae&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cda63ae",
  null
  
)

export default component.exports